import { isHttpUrl, isImageUrl } from "../detect";
import { PRIORITY, type ValueRenderer } from "../types";

export const UrlRenderer: ValueRenderer = {
  id: "url",
  match: value => {
    // Image URLs are handled by ImageRenderer — return null so it wins, not this.
    if (isImageUrl(value)) return null;
    return isHttpUrl(value) ? { priority: PRIORITY.CONTENT_SNIFFED, confidence: "high" } : null;
  },
  Component: ({ value }) => (
    <a
      href={value as string}
      target="_blank"
      rel="noopener noreferrer"
      className="text-ds-brand-500 break-all underline hover:no-underline"
    >
      {value as string}
    </a>
  ),
};
